import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import SEO from "../components/common/SEO";
import { verifyMagicLink, setToken } from "../lib/api";

export default function PortalVerify() {
  const [message, setMessage] = useState("Signing you in...");
  const [error, setError] = useState(false);
  const navigate = useNavigate();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const token = new URLSearchParams(window.location.search).get("token");
    if (!token) {
      setError(true);
      setMessage("Missing sign-in token.");
      return;
    }
    verifyMagicLink(token)
      .then(({ access_token }) => {
        setToken(access_token);
        window.history.replaceState({}, document.title, "/portal");
        navigate("/portal");
      })
      .catch(() => {
        setError(true);
        setMessage("This link is invalid, expired, or already used.");
      });
  }, [navigate]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center px-6 text-center">
      <SEO title="Signing in" path="/portal/verify" />
      {!error ? (
        <Loader2 className="mb-5 h-8 w-8 animate-spin text-sky-400" />
      ) : null}
      <p className={`text-lg ${error ? "text-slate-300" : "text-slate-400"}`} data-testid="portal-verify-message">
        {message}
      </p>
      {error && (
        <a href="/portal/login" className="mt-6 rounded-full bg-sky-400 px-6 py-3 text-sm font-medium text-ink-900 hover:bg-sky-300" data-testid="portal-verify-retry">
          Request a new link
        </a>
      )}
    </div>
  );
}
